const OFFER_DESTINATIONS: Record<string, string> = {
  'refer-a-friend': '/hive/beehive/actions/refer-a-friend',
};

export const getDestinationForOffer = (
  offer: string | null | undefined,
): string | null => (offer && OFFER_DESTINATIONS[offer]) || null;

export const getDestinationForLogin = ({
  offer,
  landingPageOffer,
}: {
  offer: string | null;
  landingPageOffer: string | null;
}): string | null =>
  offer && offer === landingPageOffer ? getDestinationForOffer(offer) : null;
